import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function";
import type {DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {DocumentAmountField} from "./DocumentAmount.component";
import {PreApprovalDetails} from "./PreApprovalDetails.component";
import {getDisplayId} from "./documentData.function";

const VoucherDocumentDetailsDTO = ({details, warnings, translate}: DocumentDetailsProps) => (
    <DocumentDataGrid>
        {details.description &&
            <DocumentDataField id="description" wide label={translate("documentData.description")}
                               value={details.description} warnings={warnings.description}/>}
        {details.supplierName &&
            <DocumentDataField id="supplierName" label={translate("documentData.supplierName")}
                               value={details.supplierName} warnings={warnings.supplierName}/>}
        {details.supplierNumber &&
            <DocumentDataField id="supplierNumber" label={translate("documentData.supplierNumber")}
                               value={details.supplierNumber} warnings={warnings.supplierNumber}/>}
        {details.invoiceNumber &&
            <DocumentDataField id="invoiceNumber" label={translate("documentData.invoiceNumber")}
                               value={details.invoiceNumber} warnings={warnings.invoiceNumber}/>}
        {details.creditBankAccount &&
            <DocumentDataField id="creditBankAccount" label={translate("documentData.bankAccount")}
                               value={details.creditBankAccount} warnings={warnings.creditBankAccount}/>}
        {details.voucherNumber &&
            <DocumentDataField id="voucherNumber" label={translate("documentData.voucherNumber")}
                               value={details.voucherNumber}/>}
        {details.voucherSeries &&
            <DocumentDataField id="voucherSeries" label={translate("documentData.voucherSeries")}
                               value={details.voucherSeries}/>}
        {!!details.invoiceDate &&
            <DocumentDataField id="documentDate" label={translate("documentData.documentDate")}
                               value={formatDate(details.invoiceDate, null)}/>}
        {!!details.dueDate &&
            <DocumentDataField id="dueDate" label={translate("documentData.dueDate")}
                               value={formatDate(details.dueDate, null)}/>}
        {!!details.createdDate &&
            <DocumentDataField id="createdDate" label={translate("documentData.createdDate")}
                               value={formatDate(details.createdDate, null)}/>}
        <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={getDisplayId(details)}/>
        {details.amount !== null &&
            <DocumentAmountField details={details} warnings={warnings.amount} translate={translate}/>}
        {details.documentOrganizationUnit &&
            <DocumentDataField id="documentOrganizationUnit" label={translate("documentData.documentOrganizationUnit")}
                               value={formatDocumentOrganizationUnit(details.documentOrganizationUnit)}
                               warnings={warnings.documentOrganizationUnit}/>}
        {details.paymentPreApprovalDetails &&
            <PreApprovalDetails paymentDetails={details.paymentPreApprovalDetails} translate={translate}/>}
    </DocumentDataGrid>
);

export default VoucherDocumentDetailsDTO;
